module.exports = __webpack_public_path__ + "img/24.589d8d8f.jpg";